/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  CustomerOfferBindingDefinitionDto,
  NoteId,
  NoteInput,
  OfferTemplateDto,
  OfferTemplateRequest,
  PaginatedOfferTemplateDto,
} from "../__ignore/schemas";

/**
 * Full DTOs with permitted source preview. Filters combine by AND; absent state includes ACTIVE and DELETED. Literal case-insensitive q searches name. Sort name ascending with ascending UUID tie-break. Protected live source calculation is skipped for unauthorized viewers.
 * @summary List reusable Offer Templates
 */
export const listOfferTemplatesQueryPageDefault = 1;

export const listOfferTemplatesQueryPerPageDefault = 20;
export const listOfferTemplatesQueryPerPageMax = 100;

export const listOfferTemplatesQuerySortDirDefault = `asc`;
export const listOfferTemplatesQuerySortKeyDefault = `name`;
export const listOfferTemplatesQueryCurrencyCodeMin = 3;
export const listOfferTemplatesQueryCurrencyCodeMax = 3;

export const listOfferTemplatesQueryCurrencyCodeRegExp = new RegExp("^[A-Z]{3}$");

export const ListOfferTemplatesQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).default(listOfferTemplatesQueryPageDefault),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listOfferTemplatesQueryPerPageMax)
    .default(listOfferTemplatesQueryPerPageDefault),
  sortDir: zod.enum(["asc", "desc"]).default(listOfferTemplatesQuerySortDirDefault),
  sortKey: zod.enum(["name"]).default(listOfferTemplatesQuerySortKeyDefault),
  q: zod.coerce.string().optional(),
  state: zod.enum(["ACTIVE", "DELETED"]).optional(),
  language: zod.enum(["ES", "EN", "FR"]).optional().describe("Supported business language."),
  currencyCode: zod.coerce
    .string()
    .min(listOfferTemplatesQueryCurrencyCodeMin)
    .max(listOfferTemplatesQueryCurrencyCodeMax)
    .regex(listOfferTemplatesQueryCurrencyCodeRegExp)
    .optional(),
});

export const ListOfferTemplatesResponse = PaginatedOfferTemplateDto;

/**
 * Structurally valid content may have unresolved inputs. Authored Chapters explicitly carry applyCommission, initialized true for new authoring, and contain no coefficient or private pricing decision. Backend assigns identity; Notes initially empty. No Expedient, ordinal, version, predecessor, creator/approver override or calculated inputs. Protected financial source manipulation requires authorization. Every sold catalog item requires an actual description in the Template language, even with null quantity or empty supplier choices. Missing text returns sales.offerTemplate.invalidSelection with located SOURCE_MISSING and no Template creation; no fallback is permitted.
 * @summary Create reusable Template
 */
export const CreateOfferTemplateBody = OfferTemplateRequest;

export const CreateOfferTemplateResponse = zod.uuid();

/**
 * Authorized current source facts and contextual variable resolution; Template preview uses authenticated actor context. No arbitrary user lookup or automatic source propagation to previously created Offers.
 * @summary Get Template and permitted preview
 */
export const GetOfferTemplateResponse = OfferTemplateDto;

/**
 * ACTIVE only; complete name/language/currency/content replacement. Preserve identity/Notes and all independently instantiated Offers. Round-trip explicit applyCommission, including false, across unrelated edits/reorder/copy. Coefficients are forbidden in Template content and preview has only source costs, never commercial totals. Protected financial changes require permission, including Currency-only changes when catalog blocks reference protected sources. Currency changes without catalog content require only ordinary Template-update permission. New catalog blocks or changed sold identities/kinds require an actual description in the input language; missing text returns sales.offerTemplate.invalidSelection with located SOURCE_MISSING and preserves the complete original Template. Language changes retain existing selections; missing new-language descriptions produce located unavailable preview facts until description addition or eligible replacement. They cannot be copied into a new Customer Offer.
 * @summary Replace Template inputs
 */
export const UpdateOfferTemplateBody = OfferTemplateRequest;

export const UpdateOfferTemplateResponse = zod.void();

/**
 * ACTIVE only; existing Offers remain unchanged.
 * @summary Soft-delete Template
 */
export const DeleteOfferTemplateResponse = zod.void();

/**
 * DELETED to ACTIVE, same identity/content/Notes.
 * @summary Restore Template
 */
export const RestoreOfferTemplateResponse = zod.void();

/**
 * ACTIVE only; Template Notes are not copied into new Offers.
 * @summary Add Template Note
 */
export const AddOfferTemplateNoteBody = NoteInput;

export const AddOfferTemplateNoteResponse = NoteId;

/**
 * ACTIVE only; preserve Note identity.
 * @summary Replace Template Note
 */
export const EditOfferTemplateNoteBody = NoteInput;

export const EditOfferTemplateNoteResponse = zod.void();

/**
 * ACTIVE only.
 * @summary Remove Template Note
 */
export const RemoveOfferTemplateNoteResponse = zod.void();

/**
 * Requires ordinary Resource read permission, not an existing Resource. Return all supported keys, including currently unresolvable keys, in stable order: $me.email then $technical_director. English labels and descriptions are metadata, not resolved values or availability claims. Email uses the authenticated Template preview user; opening rebinds to the new Offer creator. No arbitrary subject, expression or user-directory lookup is accepted. Existing evaluation reports unresolved values; literals stay literal and issued text remains frozen independently of discovery.
 * @summary Discover supported editor binding definitions
 */
export const ListOfferTemplateBindingDefinitionsResponseItem = CustomerOfferBindingDefinitionDto;
export const ListOfferTemplateBindingDefinitionsResponse = zod.array(
  ListOfferTemplateBindingDefinitionsResponseItem,
);
